type RuntimeKey =
  | 'NEXT_PUBLIC_API_URL'
  | 'NEXT_PUBLIC_AGENT_HOUSE_API_URL'
  | 'NEXT_PUBLIC_ORGANIZATION_ADMIN_APP_URL'
  | 'NEXT_PUBLIC_RESEARCH_API_URL';

declare global {
  interface Window {
    __COLISEUM_RUNTIME_CONFIG__?: Partial<Record<RuntimeKey, string>>;
  }
}

export function runtimeConfig(key: RuntimeKey, fallback: string): string {
  if (typeof window !== 'undefined') {
    const value = window.__COLISEUM_RUNTIME_CONFIG__?.[key]?.trim();
    if (value) return value.replace(/\/+$/, '');
  }
  const serverValue = typeof process !== 'undefined' ? process.env[key]?.trim() : '';
  return (serverValue || fallback).replace(/\/+$/, '');
}
